import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { VesselCaptainMapDAO } from '../../../core/services/dao/vesselCaptainMapDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';

@Component({
  selector: 'sigla-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  public model: User;
  public captain: Captain;
  public adminAccess: boolean;
  public vessels: Vessel[];

  constructor(
    private userDAO: UserDAO,
    private route: ActivatedRoute,
    private router: Router,
    private vesselCaptainMapDao: VesselCaptainMapDAO,
  ) {
    this.adminAccess = this.userDAO.currentUserIsAdmin();
    const routeSub = this.route.data.subscribe((data) => {
      this.model = data.profileResolve.userResolve;
    });
    this.subs.push(routeSub);
  }

  ngOnInit() {
    if (this.model?.captain?.id) {
      const vesselSub = this.vesselCaptainMapDao
        .getVesselsByCaptainId(this.model.captain.id)
        .subscribe((vessels) => {
          this.vessels = vessels;
        });
      this.subs.push(vesselSub);
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  cancel() {
    this.router.navigate(['manage']);
  }
}
